export default function Layout() {
    return {
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: '8px',
                    margin: '2px 8px',
                },
            },
        },
    };
}